export default __webpack_public_path__ + "static/media/soul-icon.d83021d7.png";